

    <div class="row mb-3 d-none d-lg-flex"  >
        @for (group of paymentFormData.groups; track $index) {
            <div class="col-12 col-md-6 mt-3">
                <p-card styleClass="payment-card">
                    <h5>{{group.name}}</h5>
                    
                        <div class="payment-buttons">
                            @for (button of group.buttons; track $index) {
                                
                                
                                    <!-- <form method="POST" [action]="button.redirectUrl">
                                        @for (hf of button.hiddenFields|keyvalue; track $index) {
                                            <input type="hidden" [name]="hf.key" [value]="hf.value">
                                        }
                                        <p-button [outlined]="true">
                                            <img [src]="button.imageUrl">
                                            {{button.text}}
                                        </p-button>
                                        
                                    </form> -->
                                <div class="paytrail-payment-button" (click)="selectPaymentOption(group.id, button.id, button.text, button.svgUrl)" [class.selected]="selectedPaymentOption == group.id+'|'+button.id+'|'+button.text+'|'+button.svgUrl">
                                    <div class="payment-option-logo-wrap">
                                        <img class="payment-option-logo" [src]="button.svgUrl">
                                    </div>
                                    <div class="payment-option-name">
                                        {{button.text}}
                                    </div>
                                </div>
                                
                                
                            }
                        </div>
                        
                </p-card>
            </div> 
        }
    </div>
    
    <div style="background: white; border-radius: 10px;" class="d-block  d-lg-none mb-3">
        <p-accordion [value]="0">
            @for (group of paymentFormData.groups; track $index) {
                <p-accordion-panel [value]="$index">
                    <p-accordion-header>{{group.name}}</p-accordion-header>
                    <p-accordion-content>
                        <div class="payment-buttons py-3 px-3">
                            @for (button of group.buttons; track $index) {
                                <div class="paytrail-payment-button" (click)="selectPaymentOption(group.id, button.id, button.text, button.svgUrl)" [class.selected]="selectedPaymentOption == group.id+'|'+button.id+'|'+button.text+'|'+button.svgUrl">
                                    <div class="payment-option-logo-wrap">
                                        <img class="payment-option-logo" [src]="button.svgUrl">
                                    </div>
                                    <div class="payment-option-name">
                                        {{button.text}}
                                    </div>
                                </div>
                            }
                        </div>
                        
                    </p-accordion-content>
                </p-accordion-panel>
            }
        </p-accordion>
    </div>
    
